import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","sm":"6","offset-sm":"3","md":"4","offset-md":"4"}},[_c('div',{staticClass:"py-12 px-2 text-center"},[_c('img',{staticClass:"img-store_is_close",attrs:{"src":require("@/assets/images/svg/store_is_close.svg"),"alt":"mail"}}),_c('h4',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.$t('store_closed_message'))}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }